module.exports = __webpack_public_path__ + "static/Bäckerbild 3-a26a48a146474e24023e29039dca3d4f.jpg";